import specPicApi from '../../apis/spec.pic.api';
import * as types from '../mutation-types';
import Vue from 'vue';
function genSpecPicKey (seriesId, specId, pageIndex) {
  let key = `${seriesId}_${specId}_${pageIndex}`;
  return key;
}
let getPictureItemsByConditionPromise = {};
export default {
  state: {
    specPic: {}
  },
  mutations: {
    [types.SET_SPEC_PIC_DATA] (state, { seriesId, specId, pageIndex, pics }) {
      if (pics.returncode === 0 && pics.result && pics.result.length > 0) {
        let key = genSpecPicKey(seriesId, specId, pageIndex);
        Vue.set(state.specPic, key, pics.result);
      }
    }
  },
  getters: {
    getCurrentPictureItems: state => (seriesId, specId, pageIndex) => {
      let key = genSpecPicKey(seriesId, specId, pageIndex);
      return state.specPic[key];
    }
  },
  actions: {
    getPictureItemsByCondition ({ state, commit }, { seriesId, specId, pageIndex, typeIds }) {
      let key = genSpecPicKey(seriesId, specId, pageIndex, typeIds);
      if (getPictureItemsByConditionPromise[key]) {
        return getPictureItemsByConditionPromise[key];
      }
      getPictureItemsByConditionPromise[key] = specPicApi.getPictureItemsByCondition(seriesId, specId, pageIndex, typeIds).then(function (data) {
        commit(types.SET_SPEC_PIC_DATA, { seriesId, specId, pageIndex, pics: data });
        const s = state.specPic[key];
        return Promise.resolve(s);
      });
      getPictureItemsByConditionPromise[key].then(() => {
        if (!state.specPic[key]) {
          delete getPictureItemsByConditionPromise[key];
        }
      });
      return getPictureItemsByConditionPromise[key];
    }
  },
  namespaced: true
};
